export default __webpack_public_path__ + "static/media/background2.47bba8d2.png";